

import Admin, { hasRole, Role } from '@/models/Admin'
import Discount from '@/models/Discount'

export default class DiscountPolicy {
    viewAny(_admin: Admin): boolean {
        return true
    }

    view(admin: Admin, discount: Discount) {
        return hasRole(admin, [Role.SUPER_ADMIN,Role.STATION_MANAGER,Role.STATION_OFFICER])
    }

    create(admin: Admin) {
        return hasRole(admin, [Role.SUPER_ADMIN,Role.COUNTRY_MANAGER])
    }

    update(admin: Admin, discount: Discount) {
        return hasRole(admin, [Role.SUPER_ADMIN,Role.COUNTRY_MANAGER])
    }

    restore(admin: Admin, discount: Discount) {
        return hasRole(admin, [Role.SUPER_ADMIN,Role.COUNTRY_MANAGER])
    }

    delete(admin: Admin, discount: Discount) {
        return hasRole(admin, [Role.SUPER_ADMIN,Role.COUNTRY_MANAGER])
    }

    forceDelete(_admin: Admin, _discount: Discount) {
        return false
    }
}
